module.exports = __webpack_public_path__ + "static/media/camera.e511a179.svg";